class RecipientForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.resetForm = this.resetForm.bind(this)
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.resetForm,
    )

    this.handleToggle = this.handleToggle.bind(this)

    this.listeners.add(this.els.toggle.element, 'toggle', this.handleToggle)
  }

  handleToggle () {
    if (this.els.toggle.element.hasAttribute('open')) {
      this.enableFields()
    } else {
      this.disableFields()
    }
  }

  clearFields () {
    this.els.email.element.value = ''
    this.els.name.element.value = ''
    this.els.message.element.value = ''
    this.els.date.element.value = ''
  }

  enableFields () {
    this.els.email.element.disabled = false
    this.els.name.element.disabled = false
    this.els.message.element.disabled = false
    this.els.date.element.disabled = false

    this.els.checkbox.element.disabled = false
  }

  disableFields () {
    this.els.email.element.disabled = true
    this.els.name.element.disabled = true
    this.els.message.element.disabled = true
    this.els.date.element.disabled = true

    this.els.checkbox.element.disabled = true
  }

  resetForm () {
    if (this.els.toggle.element.hasAttribute('open')) {
      this.clearFields()
    }
  }
}

if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', RecipientForm)
}
